import Vue from 'vue';
import VueI18n from 'vue-i18n';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import modelFormLocker from './modelFormLocker'

Vue.use(VueI18n);

require('./bootstrap');
require('./jquery-hacks/supplied');
require('./jquery-hacks/form');

let messages = require('./../../../lang/en_US.json');
let locale = document.head.querySelector('meta[name="locale"]');

const i18n = new VueI18n({
    locale,
    messages
});

modelFormLocker.init();

Vue.component('pagination', require('laravel-vue-pagination'));

Vue.component('content-fieldset', require('./components/ContentAndSettings/ContentFieldset.vue').default);

Vue.component('payment-return-handler-non-final', require('./components/PaymentReturnHandlerNonFinal').default);

Vue.component('resource-selector', require('./components/ResourceSelector.vue').default);
Vue.component('frontend-api-search', require('./components/Prices/FrontendApiSearch.vue').default);

Vue.component('autobooker-status', require('./components/Orders/AutobookerStatus').default);
Vue.component('partner-event-selector-input', require('./components/Partners/PartnerEventSelectorInput').default);

Vue.component('checkout-endpoint-configurator', require('./components/DeveloperTools/CheckoutEndpointConfigurator').default);
Vue.component('checkout-endpoint-button', require('./components/DeveloperTools/CheckoutEndpointButton').default);
Vue.component('order-processing-steps', require('./components/Orders/ProcessingSteps').default);

Vue.component('voucher-balance', require('./components/VoucherBalance').default);
Vue.component('tickets-search', require('./components/TicketsSearch').default);
Vue.component('event-search', require('./components/EventSearch').default);
Vue.component('customer-search', require('./components/CustomerSearch').default);
Vue.component('create-manual-order', require('./components/CreateManualOrder').default);
Vue.component('country-code-selector', require('./components/CountryCodeSelector').default);
Vue.component('order-traveller-form', require('./components/OrderTravellerForm').default);

Vue.component('order-travel-documents', require('./components/OrderTravelDocuments').default);
Vue.component('order-search', require('./components/Orders/OrderSearch.vue').default);

Vue.component('cancellation-compensation', require('./components/Orders/CancellationCompensation.vue').default);

Vue.component('adyen-drop-in', require('./components/DeveloperTools/AdyenDropIn.vue').default);

Vue.filter('inputValue', function (value) {
    if (value === true) {
        return 1;
    }

    if (value === false) {
        return 0;
    }

    return value;
})


const app = new Vue({
    i18n,
    el: '#app',
    data() {
        return {
            config: {
                altFormat: 'M	j, Y',
                altInput: true,
                dateFormat: 'Y-m-d'
            },
        }
    },
    components: {
        flatPickr
    }
});

// Allow for global tooltips
var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new bootstrap.Tooltip(tooltipTriggerEl)
})
